export default {
    changeCode (state,code) {
        state.code = code;
        localStorage.code = code
    },


    //认证状态
    changeIsAuth (state,is_auth) {
        state.is_auth = is_auth;
        localStorage.is_auth = is_auth
    },

    //用户id
    changeId (state,user_id) {
        state.user_id = user_id;
        try {
            localStorage.user_id = user_id
        } catch (e) {
            window.console.log(e)
        }
    },

    //用户身份 企业 达人 游客
    changeUserType (state,user_type) {
        state.user_type = user_type;
        localStorage.user_type = user_type
    },

    //是否运营
    changeIsOperater (state,is_operater) {
        state.is_operater = is_operater;
        localStorage.is_operater = is_operater
    },

    //认证信息，认证通过后
    changeAuthToken (state,auth_token) {
        state.auth_token = auth_token;
        localStorage.auth_token = auth_token
    },

    //达人培训方式
    changeAuthType (state,auth_type) {
        state.auth_type = auth_type;
        localStorage.auth_type = auth_type
    },

    //openid
    changeOpenId (state,openid) {
        state.openid = openid;
        localStorage.openid = openid
    },

    //unionid
    changeUnionId (state,unionid) {
        state.unionid = unionid;
        localStorage.unionid = unionid
    },

    //审核状态
    changeIsPass (state,is_pass) {
        state.is_pass = is_pass;
        localStorage.is_pass = is_pass
    },

    //新手任务
    changeNewbieTask (state,newbie_task) {
        state.newbie_task = newbie_task;
        localStorage.newbie_task = newbie_task
    },

    //站长身份
    changeIsAgent (state,is_agent) {
        state.is_agent = is_agent;
        localStorage.is_agent = is_agent
    },

    //是否开通会员
    changeRank (state,rank) {
        state.rank = rank;
        localStorage.rank = rank
    },

    //是否答题
    changeIsAnswer (state,isAnswer) {
        state.isAnswer = isAnswer;
        localStorage.isAnswer = isAnswer
    },
    changeIsInfo (state,isInfo) {
        state.isInfo = isInfo;
        localStorage.isInfo = isInfo
    },

    changeWeChatNumber (state,weChatNumber) {
        state.weChatNumber = weChatNumber;
        localStorage.weChatNumber = weChatNumber
    },
    changeWeChatFriendNum (state,weChatFriendNum) {
        state.weChatFriendNum = weChatFriendNum;
        localStorage.weChatFriendNum = weChatFriendNum
    },
    changeSource (state,source) {
        state.source = source;
        localStorage.source = source
    },
    changeLabel (state,label) {
        state.label = label;
        localStorage.label = label
    },
    changeTime (state,nowTime) {
        state.nowTime = nowTime;
        localStorage.label = nowTime
    },
    changeGetTime (state,getTime) {
        state.getTime = getTime;
        localStorage.getTime = getTime
    },
    changeMobileCon (state,mobileCon) {
        state.mobileCon = mobileCon;
    },
    changeMobileTit (state,mobileTit) {
        state.mobileTit = mobileTit;
    },
    changePreviewImage (state,previewImage) {
        state.previewImage = previewImage;
    },
    changeIsLogin (state,isLogin) {
        state.isLogin = Number(isLogin);
    },
    changeTemplatePic (state,templatePic) {
        state.templatePic = templatePic;
    },
    changeIsOfficial(state,is_official){
        state.is_official = is_official;
        localStorage.is_official = is_official
    },
    changeEpOrderTab(state,epOrderTab){
        state.epOrderTab = epOrderTab;
        localStorage.epOrderTab = epOrderTab
    },
    changeDarenOrderTab(state,darenOrderTab){
        state.darenOrderTab = darenOrderTab;
        localStorage.darenOrderTab = darenOrderTab
    }
}
